import { inject } from 'inversify-props';
import { IAuthService, ISettingService, IAxiosConfig } from '@/services';

export class AppBoot {
  @inject() private settingService!: ISettingService;
  @inject() private authService!: IAuthService;
  @inject() private axiosConfig!: IAxiosConfig;

  async activate() {
    await this.axiosConfig.activate();
    await this.settingService.activate();
    await this.authService.activate();
  }
}

export const appBoot = new AppBoot();
